import Header from "../Components/Header";
import Body from "../Components/Body";

function Home() {
  return (
    <div className="container">
      <Header />
      <Body />
    </div>
  );
}

export default Home;